import { render, staticRenderFns } from "./ArticleProducts.vue?vue&type=template&id=2503db6a&name=article-products&"
import script from "./ArticleProducts.vue?vue&type=script&lang=js&"
export * from "./ArticleProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports